<app-dashboard-box (buttonClick)="resetFilter()"
                   [buttonIconName]="'refresh'"
                   [buttonLabel]="'common.actions.reset-filter' | translate"
                   [title]="'common.title.device-administration' | translate"
                   class="transparent device-filter"
                   icon="filter_alt">

  <section class="filter-section">
    <app-input-text [formData]="searchConfig"/>
    <app-input-select [formData]="statusSelect"/>
    <app-input-select [formData]="modelSelect"/>
  </section>
</app-dashboard-box>

<app-dashboard-box [buttonLabel]="'common.fields.device-found' | translateSafe : {
                     count: getDeviceCount(),
                     total: getDeviceTotal()
                   }"
                   [title]="'common.title.device-list' | translate"
                   icon="list">
  <app-table [loading]="loading"
             [tableConfig]="tableConfig"
             [tableRows]="tableRows"/>
</app-dashboard-box>

@if (hasAccess(AccountRole.OPERATOR) && isEditDialogOpen) {
  <app-dialog-base [buttonAction]="closeEditDialog"
                   [class.open]="isEditDialogOpen"
                   [title]="selectedDevice ? `${getDeviceNumber(selectedDevice)}` : ''"
                   iconLeft="edit">
    @if (selectedDevice) {
      <app-last-activity [device]="selectedDevice!"
                         action/>
    }

    <app-button-icon (click)="toggleViewDialog(selectedDevice)"
                     action
                     iconName="visibility"/>

    <app-dialog-edit-device [device]="selectedDevice"/>
  </app-dialog-base>
}
@if (isDeviceDetailOpen) {
  <app-dialog-base (outSideClick)="closeShowDetails()"
                   [buttonAction]="closeShowDetails"
                   [class.open]="isDeviceDetailOpen"
                   [title]="selectedDevice ? `${getDeviceNumber(selectedDevice)}` : ''"
                   iconLeft="info">
    @if (selectedDevice) {
      <app-last-activity [device]="selectedDevice!"
                         action/>
    }

    @if (hasAccess(AccountRole.OPERATOR)) {
      <app-button-icon (click)="toggleEditDialog(selectedDevice)"
                       action
                       iconName="edit"/>
    }

    <app-dialog-device-detail [device]="selectedDevice"/>
  </app-dialog-base>
}

@if (hasAccess(AccountRole.ADMIN)) {
  <app-dialog-confirm [buttonAction]="closeDeleteDialog"
                      [confirmAction]="confirmDeleteDevice"
                      [isOpen]="isDeleteDialogOpen"
                      [message]="'dialogs.device.delete.message' | translateSafe"
                      [title]="'common.actions.tooltip.delete-device' | translateSafe"
                      iconLeft="warning"/>
}
